<template>
  <svg
    :width="size"
    :height="size"
    :viewBox="`0 0 ${size} ${size}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_4279_64184)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.125 14C9.57272 14 9.125 14.4477 9.125 15V24.375C9.125 24.9273 9.57272 25.375 10.125 25.375H24.375C24.9273 25.375 25.375 24.9273 25.375 24.375V15C25.375 14.4477 24.9273 14 24.375 14H10.125ZM18.9059 22.9375H20.5L18.1412 16.4375H16.2941L14 22.9375H15.5588L16.0412 21.4555H18.3941L18.9059 22.9375ZM17.2 17.9455L17.8353 19.8305L16.6 19.824L17.2 17.9455Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.25 17.25H7.5V13.375C7.5 12.8227 7.94772 12.375 8.5 12.375H23.75V4.25C23.75 3.35254 23.0225 2.625 22.125 2.625H4.25C3.35254 2.625 2.625 3.35254 2.625 4.25V15.625C2.625 16.5225 3.35254 17.25 4.25 17.25ZM11.7004 11.465L15.3556 9.19067C15.4385 9.13866 15.5065 9.06841 15.5534 8.98611C15.6004 8.90382 15.625 8.812 15.625 8.71875C15.625 8.6255 15.6004 8.53368 15.5534 8.45139C15.5065 8.36909 15.4385 8.29884 15.3556 8.24683L11.7004 5.97252C11.6087 5.91467 11.5018 5.88123 11.3913 5.87579C11.2808 5.87035 11.1708 5.89311 11.0731 5.94162C10.9754 5.99014 10.8937 6.06258 10.8367 6.15117C10.7798 6.23976 10.7498 6.34114 10.75 6.44444V10.9931C10.7498 11.0964 10.7798 11.1977 10.8367 11.2863C10.8937 11.3749 10.9754 11.4474 11.0731 11.4959C11.1708 11.5444 11.2808 11.5672 11.3913 11.5617C11.5018 11.5563 11.6087 11.5228 11.7004 11.465Z"
        :fill="color"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4279_64184"
        x="0"
        y="0"
        width="30"
        height="30"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4279_64184"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4279_64184"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "i-caption-on",
  props: {
    size: {
      type: String | Number,
      default: "26"
    },
    color: {
      type: String,
      default: "white"
    }
  }
};
</script>

<style scoped lang="less">
svg {
  transition: all 0.5s;
  path {
    transition: all 0.5s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/icons/play_control/caption_on.vue